import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import Dashboard from './pages/dashboard.js';
import Login from "./pages/Login";
import { authLoader } from "./PrivateRoute.js";
import NotFound from './pages/NotFound.js';
import {AddressableStorage, MovingDragEndDrop, MyCliDragEndDrop, NewClientDragEndDrop, PicUpDragEndDrop, ProductsShipment, ProductsStorage} from './components/DragDrop.js';
import { Company } from "pages/company.js";
import { HandBook } from "pages/handBook.js";
import { Deal } from "pages/deal.js";
import { CreateDelivery } from "pages/createDelivery.js";
import { Documents } from "./components/Documents.js";
import { DealClient } from "pages/dealClient.js";
import MenuLayout from "pages/MenuLayout.js";
import Register from "pages/Register.js";
import { MyProducts } from "pages/myProducts.js";
import ClientSettings from "pages/ClientSettings.js";
import ClientAPISettings from "pages/ClientAPISettings.js";
import { BarcodeSettings } from "pages/BarcodeSettings.js";
import ClientDocumentsSettings from "pages/ClientDocumentsSettings.js";
import AdminSettings from "pages/AdminSettings.js";
import { DeliveryClient } from "pages/deliveryClient.js";
import ClientProductStorage from "pages/ClientProductStorage.js";
import { DeliveryClientStorage } from "pages/deliveryClientStorage.js";
import MyConsumables from "pages/MyConsumables.js";
import { DeliveryClientConsumabels } from "pages/deliveryClientConsumabels.js";
import { clientDealAuthLoader, dealAuthLoader } from "components/dealAuthLoader.js";
import { ClientWorkers } from "pages/ClientWorkers.js";
import FBSAdmin from "pages/fbsAdmin.js";
import { DeliveryAdmin } from "pages/deliveryAdmin.js";
import { ClientsProducts } from "pages/ClientsProducts.js";
import { Returns } from "pages/ReturnsModern.js";
import { ClientsRSRDs } from "pages/ClientsRSRDs.js";
import { DeliveryClientReturns } from "pages/deliveryClientReturnsModern.js";
import ClientGuide from "pages/ClientGuide.js";
import { MyProductsModern } from "pages/myProductsModern.js";
import { MyTechTasks } from "pages/myTechTasks.js";
import { DealSettings } from "pages/createDealModern.js";

// роутер для url
export const Router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />
      <Route path="registration" element={<Register />} />
      {/* Защищённый layout с loader'ом */}
      <Route path="/" element={<MenuLayout />} loader={authLoader}>
        <Route path="home" element={<Dashboard />} />
        <Route path="newClients" element={<NewClientDragEndDrop />} />
        {/* <Route path="myClients" element={<Deal />} /> */}
        <Route path="myClients" element={<MyCliDragEndDrop />} />
        <Route path="fbsAdmin" element={<FBSAdmin/>} />
        <Route path="createDelivery/deal" element={<DeliveryClient />} />
        <Route path="createDelivery" element={<CreateDelivery />} />
        <Route path="pickProducts" element={<PicUpDragEndDrop />} />
        <Route path="moveProducts" element={<MovingDragEndDrop/>} />
        <Route path="saveProducts" element={<AddressableStorage />} />
        <Route path="storageProducts" element={<ProductsStorage/>} />
        <Route path="transfer" element={<ProductsShipment/>} />
        {/* <Route path="DealTable" element={<Deal />} /> */}
        {/* <Route path="DealTableForClient" element={<DealClient />} /> */}
        <Route path="clientDeal/:dealId" element={<DealClient />} loader={clientDealAuthLoader} />
        <Route path="deal/:dealId" element={<Deal />} loader={dealAuthLoader} />
        <Route path="deal/:dealId/deal" element={<DeliveryAdmin />} loader={dealAuthLoader}/>
        <Route path="company" element={<Company />} />
        <Route path="ClientProductStorage" element={<ClientProductStorage />} />
        <Route path="ClientProductStorage/deal" element={<DeliveryClientStorage />} />
        {/* <Route path="addresStorage" element={<AddressableStorage />} /> */}
        <Route path="calculator" element={<></>} />
        <Route path="handbook" element={<HandBook />} />
        <Route path="documents" element={<Documents />} />
        <Route path="myProduct" element={<MyProducts />} />
        <Route path="myProductModern" element={<MyProductsModern />} />
        <Route path="myTechTasks" element={<MyTechTasks />} />

        <Route path="createDealModern" element={<DealSettings />} />

        <Route path="ClientsProducts" element={<ClientsProducts />} />
        <Route path="myConsumables" element={<MyConsumables />} />
        <Route path="myConsumables/deal" element={<DeliveryClientConsumabels />} />
        <Route path="ClientSettings" element={<ClientSettings />} />
        <Route path="ClientAPISettings" element={<ClientAPISettings />} />
        <Route path="BarcodeSettings" element={<BarcodeSettings />} />
        <Route path="ClientDocumentsSettings" element={<ClientDocumentsSettings />} />
        <Route path="AdminSettings" element={<AdminSettings />} />
        <Route path="ClientWorkers" element={<ClientWorkers />} />
        <Route path="returns" element={<Returns />} />
        <Route path="ClientsRSRDs" element={<ClientsRSRDs />} />
        <Route path="ClientsRSRDs/deal" element={<DeliveryClientReturns />} />  
        <Route path="ClientGuide" element={<ClientGuide />} />  
        
      </Route>

      <Route path="*" element={<NotFound />} />
    </>
  )
);


export default Router;